import * as client from "../../../client";
import { ClientId, perClient } from "../../../client-features";

const REQUIRED_FIELDS = perClient({
  luminor: ["street_address"],
});

export const isRequiredField = (
  clientId: ClientId,
  field: keyof client.RawAddress | undefined
): boolean => {
  const requiredFields = REQUIRED_FIELDS[clientId] ?? [];
  return field !== undefined && requiredFields.includes(field);
};
